import DialogStyle from './dialog';

export {
	DialogStyle,
};


// WEBPACK FOOTER //
// ./src/stylecomponents/index.js